import { FC, ReactNode, useId } from 'react';
import classes from './Section.module.scss';
import { canAccessPermission, useAdminAccess } from '@/shared/model/adminAccess';

interface SectionProps {
    title?: ReactNode;
    children: ReactNode;
    className?: string;
    variant?: 'default' | 'highlighted' | 'compact' | 'no-padding' | 'plain';
    actions?: ReactNode;
    permission?: string;
}

/** Группирует содержимое страницы с заголовком, действиями и визуальным вариантом. */
export const Section: FC<SectionProps> = (
    {
        title,
        children,
        className = '',
        variant = 'default',
        actions,
        permission,
    }
) => {
    const titleId = useId();
    const allowed = useAdminAccess((state) => !permission || canAccessPermission(state.snapshot, permission));
    const sectionClass = `${classes.section} ${classes[`section--${variant}`]} ${className}`;

    if (!allowed) return null;

    return (
        <section
            className={sectionClass}
            aria-labelledby={title
                ? titleId
                : undefined
            }
        >
            {(title || actions) && (
                <div className={classes.sectionHeader}>
                    {title &&
                        <h2
                            id={titleId}
                            className={classes.sectionTitle}
                        >
                            {title}
                        </h2>
                    }
                    {actions &&
                        <div className={classes.sectionActions}>{actions}</div>
                    }
                </div>
            )}
            {children}
        </section>
    );
};
